
var React =              require("react");
var ApplicationContext = require("../../config/ApplicationContext.js");

class Tooltip extends React.Component {

    render() {
        if(this.props.isloading){ return null}

        let icon = this.props.type === "done" ? 
                        (this.props.private) ?
                                <img src={`${ApplicationContext.assetUrlPrefix}/assets/icons/icon-status-lock.svg`}/>
                                :
                                <img src={`${ApplicationContext.assetUrlPrefix}/assets/icons/icon-globe.svg`}/>
                        :
                        (this.props.type === "warn") ?
                            <div className="tooltip__container">
                                <img src={`${ApplicationContext.assetUrlPrefix}/assets/icons/icon-warning-yellow.svg`}/>
                                <div className="tooltip__container__info">{this.props.info}</div>
                            </div>
                            :
                            <div className="tooltip__container">
                                <img src={`${ApplicationContext.assetUrlPrefix}/assets/icons/icon-error.svg`}/>
                                <div className="tooltip__container__info">{this.props.info}</div>
                            </div>;

        return <div className="tooltip"> {icon} </div>
    }

}

module.exports = Tooltip;
